/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { BsPrinter } from "react-icons/bs";
import { FiShoppingBag } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { bindActionCreators } from "redux";
import { userDataActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import Loader from "../../Loader";
import RenderHome from "../home/RenderHome";
import DeductionsView, { ToolbarButton } from "./DeductionsView";
import "./Loans.css";

function MartDeduction() {
  const dispatch = useDispatch();
  const { GetMartDeduction } = bindActionCreators(userDataActionCreators, dispatch);

  const mark_deductions = useSelector((state) => state.user.mark_deductions);
  const paginate = useSelector((state) => state.user.paginate);
  const isLoading = useSelector((state) => state.user.isLoading);

  const [pageCount, setPageCount] = useState(0);
  const componentRef = useRef();

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [mark_deductions, paginate]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    GetMartDeduction(true, event.selected + 1, 15);
  };

  useEffect(() => {
    GetMartDeduction(true, 1, 15);

    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "My Mart Deductions",
  });

  const handleSearch = debounce((e) => {
    if (e.target.value) {
      GetMartDeduction(true, 1, 10, `${e.target.value}`);
    } else {
      GetMartDeduction(true, 1, 10);
    }
  }, 800);

  return (
    <div className="LoansPage">
      <RenderHome title={"Mart Deduction"}>
        {isLoading ? <Loader /> : ""}

        <DeductionsView
          ref={componentRef}
          title="Mart Deductions"
          subtitle="What your UPNMG Mart purchases have taken off your salary, month by month."
          tableTitle="Mart Deductions"
          rows={mark_deductions}
          totalRecords={paginate?.totalItems}
          onSearch={handleSearch}
          pageCount={pageCount}
          onPageChange={handlePageClick}
          emptyText="No mart deductions recorded yet."
          actions={
            <>
              <ToolbarButton icon={BsPrinter} label="Print" onClick={handlePrint} />
              <ToolbarButton
                icon={FiShoppingBag}
                tone="solid"
                label="Purchase Product"
                to={<Link to="/upnmg-shopping-mall" />}
              />
            </>
          }
        />
      </RenderHome>
    </div>
  );
}

export default MartDeduction;
